import React from "react";
import { Outlet } from "react-router-dom";

function Tool() {
  return <Outlet />;
}

export default Tool;
